export default {
  name: 'workerReview',
  miniSave: false,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest('/crewconfig/annualreview/review/worker', 'PUT', data)
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data;
    ctx.router.push({ name: `crews-crewid-safety-review-worker-review`, params: { crewid: data.crewid }, query: { sid: ctx.saveId } });
  }
}
